export default __webpack_public_path__ + "5d01f99dce0a95d8493a8316dc7952e5.png";